import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import ReactList from 'react-list'
import orderBy from 'lodash/orderBy'
import { useDispatch, useSelector } from 'react-redux'

import { APItem } from './ap-item'
import { EditAPPaying } from './edit-ap-paying'
import { filterAP, sortAP } from '../../function'

import { accountingAction } from '../../../../actions'
import { accountingSelector } from '../../../../selectors'

export const APDataTable = React.memo(({ sortOrder, openDiscardModal, closeResponseModal }) => {
  const access_token = localStorage.getItem('access_token')
  const dispatch = useDispatch()
  const [isExpand, setIsExpand] = useState({})
  const [isEdit, setIsEdit] = useState({ open: false })
  const [defaultPayings, setDefaultPayings] = useState([])

  const keyword = useSelector(accountingSelector.getKeywordSearch)
  const apFilter = useSelector(accountingSelector.getAPFilter)

  const _payings = useSelector(accountingSelector.getPayings)
  const payings = sortAP(filterAP(defaultPayings, keyword, apFilter), sortOrder)

  useEffect(() => {
    dispatch(accountingAction.getPayings(access_token))
  }, [])

  useEffect(() => {
    setIsExpand({})
  }, [apFilter.status])

  useEffect(() => {
    const payings = []
    _payings.map(p => {
      const { hardwares = [], licenses = [], vendors = [] } = p
      const info = { ...p }
      delete info['hardwares']
      delete info['licenses']
      delete info['vendors']
      const _h = hardwares.map(h => { return { ...h, ...info } })
      const _l = licenses.map(h => { return { ...h, ...info } })
      const _v = vendors.map(h => { return { ...h, ...info } })
      payings.push(..._h, ..._l, ..._v)
      return p
    })
    setDefaultPayings(orderBy(payings, 'project_name', 'asc'))
  }, [_payings])

  const handleClickEdit = idx => {
    setIsEdit({ open: true, data: payings[idx] })
  }

  const handleClose = () => {
    if (isEdit.open) {
      const actions = {
        cancel: closeResponseModal,
        discard: () => {
          setIsEdit({ open: false })
          closeResponseModal()
        },
      }
      openDiscardModal(actions)
    } else {
      setIsEdit({ open: false })
    }
  }

  const handleClickRow = idx => {
    if (isExpand[idx]) {
      const _isExpand = { ...isExpand }
      delete _isExpand[idx]
      setIsExpand(_isExpand)
    } else {
      setIsExpand({ ...isExpand, [idx]: true })
    }
  }

  const editPaying = async (type, data, state) => {
    let payload = {}
    switch (type) {
      case 'hardware_id': {
        payload = {
          accountant_paying_hardware: {
            hardware_id: data.hardware_id,
            ...state,
          },
        }
        await dispatch(accountingAction.editPaying(`${data._id}?hardware_id=${data.hardware_id}`, payload, access_token))
        break
      }
      case 'license_id': {
        payload = {
          accountant_paying_license: {
            license_id: data.license_id,
            ...state,
          },
        }
        await dispatch(accountingAction.editPaying(`${data._id}?license_id=${data.license_id}`, payload, access_token))
        break
      }
      case 'vendor_id': {
        payload = {
          accountant_paying_vendor: {
            vendor_id: data.vendor_id,
            ...state,
          },
        }
        await dispatch(accountingAction.editPaying(`${data._id}?vendor_id=${data.vendor_id}`, payload, access_token))
        break
      }
      default: break
    }
    dispatch(accountingAction.getPayings(access_token))
    setIsEdit({ open: false })
  }

  const renderItem = (index) => {
    const item = payings[index]

    return (
      <APItem
        key={ index }
        index={ index }
        item={ item }
        isExpand={ isExpand[index] }
        handleClickRow={ handleClickRow }
        handleClickEdit={ handleClickEdit }
      />
    )
  }

  return (
    <Root>
      <EditAPPaying
        isEdit={ isEdit.open }
        data={ isEdit.data }
        handleClose={ handleClose }
        editPaying={ editPaying }
      />
      <RowWrapper>
        <ReactList
          itemRenderer={ renderItem }
          length={ payings.length }
        />
      </RowWrapper>
    </Root>
  )
})

const Root = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

const RowWrapper = styled.div`
  height: 100%;
`



// WEBPACK FOOTER //
// ./src/components/accounting-dashboard/data-table/ap-paying/index.js